const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      zIndex: 1,
      width: '100%',
      '& .imgWrapper_1': {
        position: 'absolute',
        zIndex: 1,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
      '& .imgWrapper_2': {
        marginLeft: 'auto',
      },
    },
    imgWrapper: {
      width: '35vw',
      position: 'relative',
      zIndex: 0,
    },
    imgHover: {
      zIndex: 2,
    },
  }

  output[theme.mediaInverse.md] = {}

  output[theme.mediaInverse.sm] = {
    root: {
      '& .imgWrapper_1': {
        position: 'absolute',
        top: '30%',
        left: 'unset',
        right: 0,
        transform: 'translate(0, 0)',
      },
      '& .imgWrapper_2': {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '20%',
      },
    },
    imgWrapper: {
      width: '70vw',
    },
  }

  return output
}

export default style
